import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import { SAVE_LEVEL } from '../../../../constants/Level';
import { Common } from '../../../../constants/ManageApps';
import { getParentStatusValue } from './utils';

class StatusMessage extends Component {
    contentString = () => {
        const { level, appName, chainName, hotelName, value, parentValue } = this.props;

        if (level === SAVE_LEVEL.CHAIN && value === Common.active.key) {
            return `By selecting ACTIVE status, ${chainName} agrees to the terms and conditions of ${appName} on behalf of all hotels in the chain.`;
        } else if (level === SAVE_LEVEL.HOTEL && value === Common.active.key) {
            return `By selecting ACTIVE status, ${hotelName} agrees to the terms and conditions of ${appName}.`;
        } else if (level === SAVE_LEVEL.HOTEL && value === Common.inherit.key) {
            const parentStatusValue = getParentStatusValue(parentValue, level);
            return `${hotelName} is currently inheriting the chain level setting of ${parentStatusValue.toUpperCase()}; terms and conditions applied from ${chainName}`;
        }
    };

    render() {
        return <p className="spark-message__content spark-bold status-message">{this.contentString()}</p>;
    }
}

StatusMessage.propTypes = {
    appName: PropTypes.string,
    chainName: PropTypes.string,
    hotelName: PropTypes.string,
    level: PropTypes.string,
    parentValue: PropTypes.string,
    value: PropTypes.string
};

const mapStateToProps = state => {
    return {
        level: get(state, 'app.selected.level'),
        hotelName: get(state, 'app.selected.selectedHotel.name'),
        chainName: get(state, 'app.selected.chain.name')
    };
};

export default connect(mapStateToProps)(withRouter(StatusMessage));



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/StatusMessageComponent.js